import { render, staticRenderFns } from "./shedWiseDeworming.vue?vue&type=template&id=463745da&scoped=true&"
import script from "./shedWiseDeworming.vue?vue&type=script&lang=js&"
export * from "./shedWiseDeworming.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "463745da",
  null
  
)

export default component.exports